import { useEffect, useState } from 'react';
import { fetchBranchNames } from '../services/gym/catalogApi';
import {
  getReceptionistBranch,
  isReceptionistPanelScope,
} from '../services/gym/branchContext';
import {
  isWalkInMember,
  WALK_IN_GYM_MEMBER_ID,
} from '../services/receptionist/walkInMember';

/** Session branch only in receptionist panel — never leak leftover admin/receptionist session. */
export function scopedReceptionistBranch() {
  return isReceptionistPanelScope() ? (getReceptionistBranch() || '') : '';
}

export function useSaleWriteBranch(member, gymId = '') {
  const receptionist = isReceptionistPanelScope();
  const [branches, setBranches] = useState([]);
  const [pickedBranch, setPickedBranch] = useState('');

  useEffect(() => {
    if (receptionist) return undefined;
    let cancelled = false;
    fetchBranchNames()
      .then((names) => {
        if (!cancelled) setBranches(Array.isArray(names) ? names : []);
      })
      .catch(() => {
        if (!cancelled) setBranches([]);
      });
    return () => { cancelled = true; };
  }, [receptionist]);

  const walkIn = isWalkInMember(member) || String(gymId || '') === WALK_IN_GYM_MEMBER_ID;
  const memberBranch = String(member?.branch || '').trim();
  const writeBranch = receptionist
    ? (getReceptionistBranch() || '')
    : (walkIn ? pickedBranch : (memberBranch || pickedBranch));
  const showPicker = !receptionist && branches.length > 0 && (walkIn || !memberBranch);

  return {
    writeBranch,
    branches,
    pickedBranch,
    setPickedBranch,
    showPicker,
  };
}

export function SaleBranchField({ id, branches, value, onChange, className = '' }) {
  if (!branches?.length) return null;
  return (
    <div className={`owner-form-group${className ? ` ${className}` : ''}`}>
      <label className="owner-form-label" htmlFor={id}>Branch</label>
      <select
        id={id}
        className="owner-form-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select branch</option>
        {branches.map((name) => (
          <option key={name} value={name}>{name}</option>
        ))}
      </select>
    </div>
  );
}
